import Mark from "mark.js";
export default class Search {
	constructor(config) {
		this.el = config.el || document.querySelectorAll("body");
		this.searchTerm = null;
		this.markjs = null;
		this.markOptions = {
			separateWordSearch: false
		};
		this.init();
	}
	init() {
		this.attachEvents();
		// if querystring with searchterm is found
		if (this.hasSearchTerm) {
			// mark all words in body with mark-tag
			this.markWords();
			// expand the accordions that contains a mark-tag.
			this.expandAccordions();
			// scroll to first occurence
			this.scrollToFirstMarkedWord();
		}
	}
	attachEvents() {
		const self = this;
	}
	get hasSearchTerm() {
		// check if searchterm is present in querystring
		const urlParams = new URLSearchParams(window.location.search);
		const searchterm = urlParams.get("searchterm");
		this.searchTerm = searchterm;
		return searchterm ? true : false;
	}
	markWords() {
		// use https://markjs.io/ to mark words in dom
		this.markjs = new Mark(this.el);
		this.markjs.mark(this.searchTerm, this.markOptions);
	}
	scrollToFirstMarkedWord() {
		// find first mark element and scroll to it.
		let firstMarkElement = document.querySelector("mark");
		if (firstMarkElement) {
			const firstMarkElementSection = firstMarkElement.closest("section");
			// goto correct tab if we are inside tab
			this.showTab(firstMarkElement);
			this.showQuicklink(firstMarkElement);

			let blockPosition =
				firstMarkElementSection !== null &&
				firstMarkElementSection.className !== null &&
				firstMarkElementSection.className.includes("hero")
					? "nearest"
					: "center";

			let scrollToElement =
				firstMarkElement.offsetParent !== null
					? firstMarkElement
					: firstMarkElementSection;
			setTimeout(() => {
				scrollToElement.scrollIntoView({
					behavior: "smooth",
					block: blockPosition,
					inline: "center"
				});
			}, 1000);
		}
	}
	showQuicklink(firstMarkElement) {
		const quickLinks = firstMarkElement.closest(".quicklinks");
		const quickLinksGroup = firstMarkElement.closest(".quicklinks__group");
		// check if marked element is in tabs__item
		if (quickLinksGroup) {
			const quickLinkComponent = utilities.dataStorage.get(
				quickLinks,
				"component"
			);
			quickLinkComponent.showPanel(quickLinksGroup);
		}
	}
	showTab(firstMarkElement) {
		const tabItem = firstMarkElement.closest(".tabs__item");
		// check if marked element is in tabs__item
		if (tabItem) {
			const tabElement = firstMarkElement.closest(".tabs");
			const tabComponent = utilities.dataStorage.get(
				tabElement,
				"component"
			);
			tabComponent.showItem(tabItem, true);
		}
	}
	expandAccordions() {
		// find accordions in dom
		let accordions = document.querySelectorAll(".accordion");
		// loop through
		accordions.forEach(accordion => {
			// find items inside accordion
			let accordionItems = accordion.querySelectorAll(".accordion__item");
			// loop through
			accordionItems.forEach(accordionItem => {
				// check if mark-tag exists within accordionitem
				const hasMarkElement = accordionItem.getElementsByTagName(
					"MARK"
				);
				if (hasMarkElement.length) {
					// if mark-tag exist get the component from the accordion-element.
					const accordionComponent = utilities.dataStorage.get(
						accordion,
						"component"
					);
					// expand the accordionItem
					accordionComponent.expandAccordionItem(
						accordionItem,
						false,
						false
					);
				}
			});
		});
	}
}
